<template>
  <div class="container">
    <div class="top-box">
      <img src="../../../static/images/topic/top.png" />
      <div class="topTitle">
        <div>
          <img
            src="../../../static/images/topic/hot.png"
            class="hotIcon"
          />热点话题
        </div>
      </div>
      <van-search
        class="search"
        placeholder="搜索话题"
        v-model="keyword"
        shape="round"
        background="transparent"
        @search="searchHandle"
        @input="searchHandle"
      ></van-search>
    </div>
    <div class="classifyNav">
      <van-tabs
        type="line"
        v-model="active"
        title-active-color="#d62f2f"
        line-width="32px"
        line-height="5px"
        @change="typeClick"
      >
        <van-tab title="热门话题"></van-tab>
        <van-tab title="热点精选"></van-tab>
      </van-tabs>
    </div>
    <div class="hasData">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="-The End-"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getListHandle"
      >
        <div v-for="(item, index) in list" :key="index">
          <div class="topicItem" @click.stop="toHotTopicDetails(item.TopicId)">
            <div class="ti_left">
              <div class="tilTitle">#{{ item.TopicName }}#</div>
              <div class="overFlowTwo">{{ item.TopicDesc }}</div>
              <div class="times">
                浏览次数：{{ item.Views }}次
                <div>帖子数：{{ item.PostCount }}条</div>
              </div>
            </div>
            <van-image fit="cover" :src="item.BackImage" class="tiImg" />
          </div></div
      ></van-list>
    </div>
  </div>
</template>
<script>
import { postTopicList } from "@/api/topic";
import { List, Tab, Tabs, Image, Search } from "vant";
export default {
  name: "hotBlock",
  components: {
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-list": List,
    "van-image": Image,
    "van-search": Search,
  },
  data() {
    return {
      keyword: "",
      active: 0, // 0全部 1热门 2推荐

      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],
    };
  },
  methods: {
    //搜索查询
    searchHandle() {
      this.pageIndex = 1;
      this.list = [];
      this.getListHandle();
    },

    //tab切换
    typeClick(name) {
      this.active = name;
      this.pageIndex = 1;
      this.list = [];
      this.getListHandle();
    },

    //跳转话题详情
    toHotTopicDetails(id) {
      this.$router.push({ path: "/hotTopicDetails", query: { hid: id } });
    },

    //获取列表
    getListHandle() {
      var that = this;
      var data = {
        CateId: 0,
        Type: Number(that.active + 1), // 0全部 1热门 2推荐
        Keyword: that.keyword,
        Page: {
          PageSize: 20,
          PageIndex: that.pageIndex,
        },
      };
      postTopicList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  .top-box {
    width: 100%;
    height: 130px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    .topTitle {
      position: absolute;
      z-index: 2;
      bottom: 48px;
      left: 50%;
      transform: translate(-50%, 0);
      width: 350px;
      font-size: 25px;
      font-weight: bold;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      div {
        position: relative;
        .hotIcon {
          position: absolute;
          z-index: -1;
          top: -15px;
          left: -20px;
          width: 43px;
          height: 43px;
        }
      }
    }
  }
  .search {
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translate(-50%, 0);
    /deep/.van-search__content {
      width: 335px;
      height: 35px;
      background: #ffffff;
    }
  }
  .classifyNav {
    font-size: 14px;
    padding-top: 10px;
    margin-bottom: 10px;
    background-color: #ffffff;
    border-radius: 0;
    border-top: 28px solid #f5f5f5;
    /deep/.van-tab {
      flex: inherit !important;
      -webkit-flex: inherit !important;
      width: 100px !important;
      font-size: 16px !important;
    }
    /deep/.van-tab--active {
      font-weight: bold;
    }
    /deep/.van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
      border: none;
    }
  }
}
</style>
